import script from "./CardFragmentEditView.vue?vue&type=script&setup=true&lang=js"
export * from "./CardFragmentEditView.vue?vue&type=script&setup=true&lang=js"

import "./CardFragmentEditView.vue?vue&type=style&index=0&id=047faab1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-047faab1"]])

export default __exports__